(function() {
  'use strict';
  const CH_CFG = window.chChatbotConfig || {};

  const WORKER_URL = CH_CFG.workerUrl;
  const STORE_URL = CH_CFG.storeUrl;
  const CONTACT_EMAIL = CH_CFG.contactEmail;
  const CHATBOT_ICON_URL = CH_CFG.iconUrl;
  const TURNSTILE_SITE_KEY = CH_CFG.turnstileSiteKey;
  const HISTORY_KEY = 'ch_product_history';

  let turnstileToken = null;
  let turnstileWidgetId = null;
  let turnstilePendingResolve = null;
  let isLoading = false;

  function generateCaseId() {
    const chars = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789'; // sin 0/O, 1/I/L
    const randomValues = crypto.getRandomValues(new Uint8Array(7));
    let id = 'CH-';
    for (let i = 0; i < 7; i++) {
      id += chars[randomValues[i] % chars.length];
    }
    return id;
  }

  let sessionId = sessionStorage.getItem('ch_session_id');
  if (!sessionId) {
    sessionId = generateCaseId();
    sessionStorage.setItem('ch_session_id', sessionId);
  }

  const widget = document.getElementById('chat-widget');
  const fab = document.getElementById('chat-fab');
  const fabLabel = document.getElementById('fab-label');
  const closeBtn = document.getElementById('close-chat-btn');
  const messagesEl = document.getElementById('chat-messages');
  const inputEl = document.getElementById('chat-input');
  const sendBtn = document.getElementById('send-btn');
  const historyPanel = document.getElementById('history-panel');
  const toggleHistoryBtn = document.getElementById('toggle-history-btn');
  const closeHistoryBtn = document.getElementById('close-history-btn');
  const historyList = document.getElementById('history-list');
  const historyEmpty = document.getElementById('history-empty');

  if (!widget || !fab) return;

  /* Turnstile solo se carga cuando el usuario abre el chat — evita el
     costo de red/parseo en cada pagina para visitantes que nunca lo abren. */
  let turnstileScriptRequested = false;
  function loadTurnstileScript() {
    if (turnstileScriptRequested || window.turnstile) return;
    turnstileScriptRequested = true;
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    s.async = true;
    document.head.appendChild(s);
  }

  function ensureTurnstile() {
    loadTurnstileScript();
    return new Promise((resolve) => {
      if (window.turnstile) {
        if (turnstileWidgetId === null) {
          turnstileWidgetId = window.turnstile.render('#turnstile-widget', {
            sitekey: TURNSTILE_SITE_KEY,
            size: 'invisible',
            theme: 'light',
            appearance: 'interaction-only',
            callback: (token) => {
              turnstileToken = token;
              if (turnstilePendingResolve) {
                turnstilePendingResolve(token);
                turnstilePendingResolve = null;
              }
            },
            'expired-callback': () => { turnstileToken = null; },
            'error-callback': () => { turnstileToken = null; },
          });
        }
        resolve();
        return;
      }

      let attempts = 0;
      const interval = setInterval(() => {
        attempts++;
        if (window.turnstile) {
          clearInterval(interval);
          ensureTurnstile().then(resolve);
        } else if (attempts > 50) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  async function getToken() {
    if (turnstileToken) return turnstileToken;
    await ensureTurnstile();
    if (!window.turnstile || turnstileWidgetId === null) return null;

    return new Promise((resolve) => {
      const timeout = setTimeout(() => {
        turnstilePendingResolve = null;
        resolve(null);
      }, 10000);

      turnstilePendingResolve = (token) => {
        clearTimeout(timeout);
        resolve(token);
      };

      turnstileToken = null;
      try {
        window.turnstile.reset(turnstileWidgetId);
      } catch {}
      window.turnstile.execute(turnstileWidgetId);
    });
  }

  function getFetchErrorMessage(err) {
    if (!err || !err.message) return 'Something went wrong. Please try again in a moment.';
    if (err.message === 'turnstile_failed') {
      return 'Security check failed. Please refresh the page and try again.';
    }
    if (err.message === 'Verification failed' || err.message === 'Verification required') {
      return 'Security verification failed. Please refresh the page and try again.';
    }
    if (err.message === 'Too many requests. Please wait a moment.') {
      return err.message;
    }
    return 'Something went wrong. Please try again in a moment.';
  }

  async function workerFetch(path, method = 'GET', body = null) {
    const options = {
      method,
      headers: { 'Content-Type': 'application/json' },
    };

    let finalPath = path;

    if (method === 'POST') {
      const token = await getToken();
      if (!token) throw new Error('turnstile_failed');
      options.body = JSON.stringify({ ...body, turnstileToken: token, sessionId });
    } else if (sessionId) {
      finalPath += (path.includes('?') ? '&' : '?') + 'sessionId=' + encodeURIComponent(sessionId);
    }

    let res;
    try {
      res = await fetch(`${WORKER_URL}${finalPath}`, options);
    } catch {
      throw new Error('network_failed');
    }

    const data = await res.json().catch(() => ({}));

    if (method === 'POST') {
      turnstileToken = null;
    }

    if (res.status === 403 || res.status === 429) {
      throw new Error(data.error || 'request_failed');
    }

    if (!res.ok && !data.error) {
      throw new Error('request_failed');
    }

    return data;
  }

  let isOpen = false;

  function toggleChat() {
    isOpen = !isOpen;
    if (isOpen) {
      widget.classList.remove('hidden-state');
      fab.classList.add('ch-cb-hidden');
      if (fabLabel) fabLabel.classList.add('ch-cb-hidden');
      ensureTurnstile();
      if (messagesEl.children.length === 0) showWelcome();
    } else {
      widget.classList.add('hidden-state');
      fab.classList.remove('ch-cb-hidden');
      if (fabLabel) fabLabel.classList.remove('ch-cb-hidden');
      historyPanel.classList.remove('open');
    }
  }

  fab.addEventListener('click', toggleChat);
  if (fabLabel) fabLabel.addEventListener('click', toggleChat);
  closeBtn.addEventListener('click', toggleChat);

  toggleHistoryBtn.addEventListener('click', () => {
    renderHistory();
    historyPanel.classList.add('open');
  });
  closeHistoryBtn.addEventListener('click', () => historyPanel.classList.remove('open'));

  function getHistory() {
    try {
      const raw = localStorage.getItem(HISTORY_KEY);
      if (!raw) return [];
      const history = JSON.parse(raw);
      const today = new Date().toDateString();
      return history.filter((item) => item.date === today);
    } catch {
      return [];
    }
  }

  function saveHistory(query, products) {
    try {
      let history = getHistory();
      history.unshift({ query, products, date: new Date().toDateString(), ts: Date.now() });
      if (history.length > 10) history = history.slice(0, 10);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
    } catch {}
  }

  function renderHistory() {
    const history = getHistory();
    if (history.length === 0) {
      historyEmpty.style.display = 'flex';
      return;
    }
    historyEmpty.style.display = 'none';
    historyList.innerHTML = '';
    history.forEach((item) => {
      const section = document.createElement('div');
      section.innerHTML = `
        <p class="ch-cb-history-query">${escapeHtml(item.query)}</p>
        ${item.products.slice(0, 2).map((p) => `
          <a href="${p.url}" target="_blank" rel="noopener" class="ch-cb-history-item">
            ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.imageAlt)}" width="40" height="40" class="ch-cb-product-img ch-cb-product-img--sm">` : '<div class="ch-cb-product-img ch-cb-product-img--sm ch-cb-product-img--placeholder"></div>'}
            <div>
              <p class="ch-cb-history-item-title">${escapeHtml(p.title)}</p>
              <p class="ch-cb-price">$${p.price} AUD</p>
            </div>
          </a>
        `).join('')}
      `;
      historyList.appendChild(section);
    });
  }

  function addBotMessage(content, isHTML = false) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ch-cb-msg-row';
    wrapper.innerHTML = `
      <div class="ch-cb-avatar">
        <img alt="Carla" width="48" height="48" src="https://cdn.shopify.com/s/files/1/0578/3846/9201/files/CARLA-CHATBOT.webp?v=1783410276">
      </div>
      <div class="ch-cb-bubble ch-cb-bubble--bot">
        ${isHTML ? content : `<p>${escapeHtml(content)}</p>`}
      </div>
    `;
    messagesEl.appendChild(wrapper);
    scrollToBottom();
    return wrapper;
  }

  function addUserMessage(text) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ch-cb-msg-row ch-cb-msg-row--user';
    wrapper.innerHTML = `
      <div class="ch-cb-bubble ch-cb-bubble--user">
        <p>${escapeHtml(text)}</p>
      </div>
    `;
    messagesEl.appendChild(wrapper);
    scrollToBottom();
  }

  function addTypingIndicator() {
    const wrapper = document.createElement('div');
    wrapper.className = 'ch-cb-msg-row';
    wrapper.id = 'typing-indicator';
    wrapper.innerHTML = `
      <div class="ch-cb-avatar">
        <img alt="Carla" width="48" height="48" src="${CHATBOT_ICON_URL}">
      </div>
      <div class="ch-cb-bubble ch-cb-bubble--bot ch-cb-bubble--typing">
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
        <span class="typing-dot"></span>
      </div>
    `;
    messagesEl.appendChild(wrapper);
    scrollToBottom();
  }

  function removeTypingIndicator() {
    const el = document.getElementById('typing-indicator');
    if (el) el.remove();
  }

  function addButtons(buttons) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ch-cb-actions';
    buttons.forEach((btn) => {
      const el = document.createElement('button');
      el.type = 'button';
      el.className = 'branch-btn';
      el.textContent = btn.label;
      el.addEventListener('click', () => btn.action());
      wrapper.appendChild(el);
    });
    messagesEl.appendChild(wrapper);
    scrollToBottom();
  }

  function addProductCards(products, searchQuery) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ch-cb-actions ch-cb-actions--wide';
    products.slice(0, 4).forEach((p) => {
      const card = document.createElement('a');
      card.href = p.url;
      card.target = '_blank';
      card.rel = 'noopener';
      card.className = 'ch-cb-product-card';
      card.innerHTML = `
        ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.imageAlt)}" width="56" height="56" class="ch-cb-product-img">` : '<div class="ch-cb-product-img ch-cb-product-img--placeholder"></div>'}
        <div class="ch-cb-product-info">
          <p class="ch-cb-product-title">${escapeHtml(p.title)}</p>
          <p class="ch-cb-price">$${p.price} AUD</p>
          <p class="ch-cb-link">View product →</p>
        </div>
      `;
      wrapper.appendChild(card);
    });
    if (products.length >= 4) {
      const seeAll = document.createElement('a');
      seeAll.href = `${STORE_URL}/search?q=${encodeURIComponent(searchQuery)}`;
      seeAll.target = '_blank';
      seeAll.rel = 'noopener';
      seeAll.className = 'ch-cb-see-all';
      seeAll.textContent = 'See all results →';
      wrapper.appendChild(seeAll);
    }
    messagesEl.appendChild(wrapper);
    scrollToBottom();
    saveHistory(searchQuery, products);
  }

  function addAnythingElse() {
    setTimeout(() => {
      addBotMessage('Is there anything else I can help you with?');
      addButtons([backToMenuButton()]);
    }, 600);
  }

  function scrollToBottom() {
    setTimeout(() => { messagesEl.scrollTop = messagesEl.scrollHeight; }, 50);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function resetState() {
    messagesEl.innerHTML = '';
  }

  function backToMenuButton() {
    return { label: '← Back to main menu', action: () => { resetState(); showWelcome(); } };
  }

  function addBranchButtons() {
    addButtons([
      { label: '📦 My Order', action: () => handleBranch('my-order') },
      { label: '🔄 Returns & Refunds', action: () => handleBranch('returns') },
      { label: '🚚 Shipping', action: () => handleBranch('shipping') },
      { label: '🧾 My Invoice', action: () => handleBranch('invoice') },
      { label: '💬 Contact Us', action: () => handleBranch('contact') },
    ]);
  }

  function showWelcome() {
    resetState();
    addBotMessage("G'day! I'm Carla. How can I help you today?");
    addBranchButtons();
  }

  function handleBranch(branch) {
    addUserMessage(getBranchLabel(branch));

    switch (branch) {
      case 'my-order': showOrderBranch(); break;
      case 'returns': showReturnsBranch(); break;
      case 'shipping': showShippingBranch(); break;
      case 'invoice': showInvoiceBranch(); break;
      case 'contact': showContactBranch(); break;
    }
  }

  function getBranchLabel(branch) {
    const labels = {
      'my-order': '📦 My Order',
      returns: '🔄 Returns & Refunds',
      shipping: '🚚 Shipping',
      invoice: '🧾 My Invoice',
      contact: '💬 Contact Us',
    };
    return labels[branch] || branch;
  }

  function showOrderBranch() {
    addBotMessage('I can help you with your order! Please enter your email address and order number.');
    showVerificationForm('order');
  }

  async function handleOrderVerification(email, orderNumber) {
    addTypingIndicator();
    try {
      const data = await workerFetch('/order', 'POST', { email, orderNumber });
      removeTypingIndicator();

      if (data.error) {
        addBotMessage("I couldn't find an order with those details. Please double-check your email and order number (e.g. 1001 or #1001).");
        addButtons([
          { label: '🔄 Try again', action: showOrderBranch },
          { label: '💬 Contact Us', action: () => handleBranch('contact') },
        ]);
        return;
      }

      const o = data.order;
      const statusMap = {
        fulfilled: '✅ Delivered',
        partial: '📦 Partially shipped',
        unfulfilled: '🔄 Being prepared',
        null: '🔄 Being prepared',
      };
      const statusLabel = statusMap[o.fulfillmentStatus] || o.fulfillmentStatus;

      let trackingHtml = '';
      if (o.tracking && o.tracking.number) {
        trackingHtml = o.tracking.url
          ? `<p class="ch-cb-mt">🚚 <strong>${escapeHtml(o.tracking.company)}</strong> — <a href="${o.tracking.url}" target="_blank" rel="noopener" class="ch-cb-inline-link">Track your parcel: ${escapeHtml(o.tracking.number)}</a></p>`
          : `<p class="ch-cb-mt">🚚 <strong>${escapeHtml(o.tracking.company)}</strong> — Tracking: ${escapeHtml(o.tracking.number)}</p>`;
      } else if (o.fulfillmentStatus === 'unfulfilled' || !o.fulfillmentStatus) {
        trackingHtml = '<p class="ch-cb-order-note">Your order is being prepared — tracking will be available once it ships.</p>';
      }

      const itemsHtml = o.items.map((i) => `<li>${i.quantity}x ${escapeHtml(i.title)}</li>`).join('');

      addBotMessage(`
        <p><strong>${escapeHtml(o.name)}</strong> — ${statusLabel}</p>
        ${trackingHtml}
        <ul class="ch-cb-order-list">${itemsHtml}</ul>
      `, true);

      addButtons([
        { label: '❌ Cancel my order', action: showCancelInfo },
        backToMenuButton(),
      ]);
    } catch (err) {
      removeTypingIndicator();
      addBotMessage(getFetchErrorMessage(err));
      addAnythingElse();
    }
  }

  function showCancelInfo() {
    addBotMessage(`To cancel your order, please contact us urgently at <strong>${escapeHtml(CONTACT_EMAIL)}</strong> with your order number. Cancellations are only possible before your order has been dispatched.`, true);
    addAnythingElse();
  }

  function showReturnsBranch() {
    addBotMessage('How can I help you with returns?');
    addButtons([
      { label: 'ℹ️ How does it work?', action: showReturnsInfo },
      { label: '📋 I have an issue with my order', action: showReturnsForm },
      backToMenuButton(),
    ]);
  }

  async function showReturnsInfo() {
    addUserMessage('ℹ️ How does it work?');
    addTypingIndicator();
    try {
      const data = await workerFetch('/returns-info');
      removeTypingIndicator();
      if (data.error) throw new Error();
      addBotMessage(`<div class="policy-content">${data.body}</div>`, true);
    } catch {
      removeTypingIndicator();
      addBotMessage('Our returns policy allows returns within 30 days of delivery for items in original condition. Please contact us to start the process.');
    }
    addAnythingElse();
  }

  function showReturnsForm() {
    addUserMessage('📋 I have an issue with my order');
    addBotMessage("I'm sorry to hear that! Please fill in the details below and we'll get back to you as soon as possible.");
    showContactForm('returns');
  }

  function showShippingBranch() {
    addBotMessage('What would you like to know about shipping?');
    addButtons([
      { label: '⏱️ Delivery times', action: () => fetchShippingSection('delivery-times', 'delivery times') },
      { label: '🗺️ Shipping zones', action: () => fetchShippingSection('shipping-zones', 'shipping zones') },
      { label: '🆓 Free shipping', action: () => fetchShippingSection('free-shipping', 'free shipping') },
      { label: '💰 Costs', action: () => fetchShippingSection('shipping-costs', 'shipping costs') },
      backToMenuButton(),
    ]);
  }

  async function fetchShippingSection(sectionKey, label) {
    addUserMessage(label);
    addTypingIndicator();
    try {
      const data = await workerFetch(`/shipping?section=${sectionKey}`);
      removeTypingIndicator();
      if (data.error) throw new Error();
      addBotMessage(`<div class="policy-content">${data.body}</div>`, true);
    } catch {
      removeTypingIndicator();
      addBotMessage(`I couldn't load that shipping information right now. Please visit our <a href="${STORE_URL}/policies/shipping-policy" target="_blank" rel="noopener" class="ch-cb-inline-link">Shipping Policy page</a> for full details.`, true);
    }
    addAnythingElse();
  }

  function showInvoiceBranch() {
    addBotMessage('I can get your invoice right away! Please enter your email address and order number.');
    showVerificationForm('invoice');
  }

  async function handleInvoiceVerification(email, orderNumber) {
    addTypingIndicator();
    try {
      const data = await workerFetch('/invoice', 'POST', { email, orderNumber });
      removeTypingIndicator();

      if (data.error) {
        addBotMessage("I couldn't find an order with those details. Please double-check your email and order number.");
        addButtons([
          { label: '🔄 Try again', action: showInvoiceBranch },
          { label: '💬 Contact Us', action: () => handleBranch('contact') },
        ]);
        return;
      }

      addBotMessage(`
        <p>Here is your invoice for <strong>${escapeHtml(data.orderName)}</strong>:</p>
        <a href="${data.url}" target="_blank" rel="noopener" class="ch-cb-download-btn">
          ⬇️ Download Invoice PDF
        </a>
      `, true);
      addAnythingElse();
    } catch (err) {
      removeTypingIndicator();
      addBotMessage(getFetchErrorMessage(err));
      addAnythingElse();
    }
  }

  function showContactBranch() {
    addBotMessage("We'd love to hear from you! Fill in the form below and we'll get back to you Monday–Friday.");
    showContactForm('contact');
  }

  function showVerificationForm(type) {
    const wrapper = document.createElement('div');
    wrapper.className = 'ch-cb-actions ch-cb-actions--wide';
    wrapper.innerHTML = `
      <input type="email" placeholder="Your email address" class="ch-cb-field" id="verify-email">
      <input type="text" placeholder="Order number (e.g. 1001)" class="ch-cb-field" id="verify-order">
      <button type="button" class="ch-cb-btn-primary" id="verify-submit">
        ${type === 'invoice' ? '🧾 Get my invoice' : '🔍 Track my order'}
      </button>
      <button type="button" class="branch-btn" id="verify-back">← Back to main menu</button>
    `;
    messagesEl.appendChild(wrapper);
    scrollToBottom();

    document.getElementById('verify-back').addEventListener('click', () => { resetState(); showWelcome(); });

    document.getElementById('verify-submit').addEventListener('click', () => {
      const email = document.getElementById('verify-email').value.trim();
      const orderNumber = document.getElementById('verify-order').value.trim();
      if (!email || !orderNumber) {
        addBotMessage('Please enter both your email and order number.');
        return;
      }
      addUserMessage(`${email} / #${orderNumber.replace('#', '')}`);
      wrapper.remove();
      if (type === 'invoice') handleInvoiceVerification(email, orderNumber);
      else handleOrderVerification(email, orderNumber);
    });
  }

  function showContactForm(type) {
    const reasonOptions = type === 'returns'
      ? ['Product arrived damaged', 'Wrong product received', 'Other']
      : ['Order enquiry', 'Product question', 'Shipping enquiry', 'Other'];

    const wrapper = document.createElement('div');
    wrapper.className = 'ch-cb-actions ch-cb-actions--wide';
    wrapper.innerHTML = `
      <input type="text" placeholder="Your name" class="ch-cb-field" id="form-name">
      <input type="email" placeholder="Your email" class="ch-cb-field" id="form-email">
      ${type === 'returns' ? '<input type="text" placeholder="Order number (e.g. 1001)" class="ch-cb-field" id="form-order">' : ''}
      <select class="ch-cb-select" id="form-reason">
        ${reasonOptions.map((r) => `<option value="${r}">${r}</option>`).join('')}
      </select>
      <textarea placeholder="Tell us more..." rows="3" class="ch-cb-textarea" id="form-message"></textarea>
      <button type="button" class="ch-cb-btn-primary" id="form-submit">
        📨 Send message
      </button>
      <button type="button" class="branch-btn" id="form-back">← Back to main menu</button>
    `;
    messagesEl.appendChild(wrapper);
    scrollToBottom();

    document.getElementById('form-back').addEventListener('click', () => { resetState(); showWelcome(); });

    document.getElementById('form-submit').addEventListener('click', async () => {
      const name = document.getElementById('form-name').value.trim();
      const email = document.getElementById('form-email').value.trim();
      const reason = document.getElementById('form-reason').value;
      const message = document.getElementById('form-message').value.trim();
      const orderNumber = type === 'returns' ? document.getElementById('form-order')?.value.trim() : '';

      if (!name || !email || !message) {
        addBotMessage('Please fill in all required fields.');
        return;
      }

      wrapper.remove();
      addUserMessage(`${name} — ${reason}`);
      addTypingIndicator();

      try {
        const data = await workerFetch('/contact', 'POST', { name, email, reason, message, orderNumber, formType: type });
        removeTypingIndicator();

        if (data.error) {
          addBotMessage(`Something went wrong sending your message. Please try emailing us directly at <strong>${escapeHtml(CONTACT_EMAIL)}</strong>.`, true);
        } else {
          addBotMessage(data.message || "Thanks! We've received your message and will get back to you within 1–2 business days.");
        }
      } catch {
        removeTypingIndicator();
        addBotMessage('Something went wrong. Please try again or email us directly.');
      }
      addAnythingElse();
    });
  }

  async function handleFreeText(message) {
    addUserMessage(message);
    addTypingIndicator();
    isLoading = true;

    try {
      const data = await workerFetch('/chat', 'POST', { message });
      removeTypingIndicator();
      isLoading = false;

      if (data.error) {
        addBotMessage('I had trouble understanding that. Could you try rephrasing, or pick one of the options below?');
        addBranchButtons();
        return;
      }

      if (data.type === 'branch') {
        addBotMessage(data.message);
        handleBranch(data.branch);
        return;
      }

      if (data.type === 'products') {
        addBotMessage(data.message);
        addProductCards(data.products, message);
        addAnythingElse();
        return;
      }

      if (data.type === 'no_products') {
        addBotMessage(data.message);
        addAnythingElse();
        return;
      }

      // Cualquier otra cosa (incluido type: 'unknown') — mantener conversación
      addBotMessage(data.message || "I'm not sure I can help with that yet. Here's what I can do for you:");
      addBranchButtons();
    } catch (err) {
      removeTypingIndicator();
      isLoading = false;
      addBotMessage(getFetchErrorMessage(err));
    }
  }

  sendBtn.addEventListener('click', () => {
    const msg = inputEl.value.trim();
    if (!msg || isLoading) return;
    inputEl.value = '';
    handleFreeText(msg);
  });

  inputEl.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      const msg = inputEl.value.trim();
      if (!msg || isLoading) return;
      inputEl.value = '';
      handleFreeText(msg);
    }
  });

  try {
    const raw = localStorage.getItem(HISTORY_KEY);
    if (raw) {
      const history = JSON.parse(raw);
      const today = new Date().toDateString();
      const filtered = history.filter((item) => item.date === today);
      localStorage.setItem(HISTORY_KEY, JSON.stringify(filtered));
    }
  } catch {}
})();
